import Dexie from 'dexie';

export class AppDatabase extends Dexie {
  keyValue: Dexie.Table<any, string>;
  
  constructor() {  
    super('HumanDatabase');
    
    //
    // Define tables and indexes
    // (Here's where the implicit table props are dynamically created)
    //
    this.version(1).stores({
      keyValue: ',value'
    });
    
    // The following lines are needed for it to work across typescipt using babel-preset-typescript:
    this.keyValue = this.table('keyValue');
  }
}
